import './InvalidOrMissingEmail.scss';

import { string } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

export const InvalidOrMissingEmail = ({ page }) => (
  <div className="preferences-invalid-email-container">
    <div className="preferences-invalid-missing-email-messaging">
      <Link
        className="preferences-people-link"
        to="profile/contact-information">
        Update your email address
      </Link>
      {` to make changes to your ${page} preferences.`}
    </div>
  </div>
);

InvalidOrMissingEmail.propTypes = {
  page: string.isRequired
};
